import template from './create.html';
import controller from './create.controller';

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
		// Using a '.' within a state name declares a child within a parent.
		// So you have a new state 'Cities' within the parent 'app.private' state.
		.state('app.private.lines.edit', {
			controller,
			template,
			url: '/edit/:lineId',
			controllerAs: 'vm',
			'resolve': {
				'Line': function($state, $stateParams, LineComponent, Toast) {
					'ngInject';

					return LineComponent.fetchLine($stateParams.lineId, 'translations,stations')
						.then(function(res) {
							if (res.data && res.data.errors) {
								Toast.responseError(res.data.errors);
								$state.go('app.private.lines.list');
							} else {
								return res;
							}
						});
				}
			}
		});
}

export default routeConfig;




/** WEBPACK FOOTER **
 ** ./client/private/lines/create/edit.route.js
 **/